export const SCRIPT_CAPTCHA = 'https://www.google.com/recaptcha/api.js?render={key}'